<template>
  <svg
    class="drop-shadow"
    id="drop-shadow"
    xmlns="http://www.w3.org/2000/svg"
    :width="viewportWidth"
    :height="viewportHeight"
    :viewBox="svgViewbox"
    fill="none"
  >
    <defs>
      <filter
        id="trans-shadow"
        x="-200%"
        y="-200%"
        width="500%"
        height="500%"
        color-interpolation-filters="sRGB"
      >
        <feColorMatrix
          type="matrix"
          values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1000 0"
          result="boostedInput"
          color-interpolation-filters="sRGB"
        />
        <feOffset
          dx="0"
          dy="0"
          color-interpolation-filters="sRGB"
        />
        <feGaussianBlur
          stdDeviation="40"
          color-interpolation-filters="sRGB"
        />
        <feComposite
          operator="out"
          in2="boostedInput"
          color-interpolation-filters="sRGB"
        />
      </filter>
    </defs>
    <rect
      class="drop-shadow__rect"
      filter="url(#trans-shadow)"
      :x="shadowOffsetX"
      :y="shadowOffsetY"
      :width="rectWidth"
      :height="rectHeight"
      :fill="shadowColor"
      fill-opacity="0.1"
      :opacity="shadowOpacity"
    />
  </svg>
</template>

<script>
export default {
  name: "TheDropShadowSVGOverlay",
  props: {
    padWidth: {
      required: true,
    },
    padHeight: {
      required: true,
    },
  },
  data: function () {
    return {

    }
  },
  computed: {
    svgShadowConfiguration: function() {
      if (!this.$store.getters.getShadowForCurrentVariation) {
        throw new Error('Отсутствует конфигурация тени, свяжитесь с фиксиками!')
      }
      return this.$store.getters.getShadowForCurrentVariation
    },

    shadowBlur: function() {
      return this.svgShadowConfiguration.blur
    },
    shadowColor: function() {
      return this.svgShadowConfiguration.color
    },
    shadowOpacity: function() {
      return this.svgShadowConfiguration.opacity
    },

    viewportWidth: function() {
      return this.padWidth
    },
    viewportHeight: function() {
      return this.padHeight
    },
    svgViewbox: function() {
      return `0 0 ${this.viewportWidth} ${this.viewportHeight}`
    },
    rectWidth: function() {
      let widthInPercent = this.$store.getters.getVideoWidthInPercent / 100
      let scaledWidth = this.viewportWidth * widthInPercent
      return +scaledWidth.toFixed(0)
    },
    rectHeight: function() {
      let heightInPercent = this.$store.getters.getVideoHeightInPercent / 100
      let scaledHeight = this.viewportHeight * heightInPercent
      return +scaledHeight.toFixed(0)
    },

    shadowOffsetX: function() {
      let draggableOffsetStep = ((this.viewportWidth - this.rectWidth) / 2 + this.rectWidth) / 100
      let draggableOffsetX = draggableOffsetStep * this.$store.getters.getVideoDraggedOffsetXInPercent
      let centeringOffsetX = (this.viewportWidth - this.rectWidth) / 2
      return centeringOffsetX + draggableOffsetX
    },
    shadowOffsetY: function() {
      let draggableOffsetStep = ((this.viewportHeight - this.rectHeight) / 2 + this.rectHeight) / 100
      let draggableOffsetY = draggableOffsetStep * this.$store.getters.getVideoDraggedOffsetYInPercent
      let centeringOffsetY = (this.viewportHeight - this.rectHeight) / 2
      return draggableOffsetY + centeringOffsetY
    },
  },
  methods: {
  },
  mounted() {
  },
  updated() {
  }
}
</script>

<style lang="scss">
.drop-shadow {
  position: relative;
}
</style>